import './style/accountSelect.scss';

import {CloseButton, Loader, WithBackground} from '@dvrd/dvr-controls';

import React, {MouseEventHandler, PropsWithChildren, useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {BluemateButton, BluemateSelect} from '../controls';

import {SelectableAccount} from '../../util/interfaces';

interface Props {
    active: boolean;
    onDeactivate: MouseEventHandler;
    onImport: MouseEventHandler;
    onChangeAccount: (accountId: string) => void;
    accounts: SelectableAccount[];
    currentAccount: string;
    loading: boolean;
    title: string;
}

export default function AccountSelect(props: PropsWithChildren<Props>) {
    const {active, currentAccount, accounts, onDeactivate, onChangeAccount, onImport, loading, title, children} = props;
    const {t} = useTranslation();
    const selectItems = useMemo(() => {
        return accounts.map((account: SelectableAccount) => ({value: account.id, label: account.label}));
    }, [accounts]);

    function renderBody() {
        return (
            <div className='body-container'>
                <Loader active={loading} />
                {children}
                <div className='select-container'>
                    <label className='sub-title'>{t('accountSelect.fetchFrom', 'Ophalen uit:')}</label>
                    <BluemateSelect
                        value={currentAccount}
                        onChange={onChangeAccount}
                        items={selectItems}
                        itemsHeight='30rem'
                        highlightSelected
                        dynamicWidth
                    />
                </div>
            </div>
        );
    }

    return (
        <WithBackground active={active} onClose={onDeactivate}>
            <div className='account-select default-popup'>
                <div className='header-container'>
                    <label className='header-title'>{title}</label>
                    <CloseButton onClick={onDeactivate} />
                </div>
                {renderBody()}
                <div className='footer-container btn-2'>
                    <BluemateButton onClick={onDeactivate} label={t('accountSelect.back', 'Terug')} secondary />
                    <BluemateButton onClick={onImport} label={t('accountSelect.import', 'Importeren')} />
                </div>
            </div>
        </WithBackground>
    );
}
